import React, { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import nextArrow from '../../assets/small-next-white-icon.svg'
import useTemplateHook from '../template/templateHook'
import Profile from '../../assets/profile'
import Watchlist from '../../assets/myWatchlist'
import Favorite from '../../assets/favorite'
import Subscription from '../../assets/subscription'
import Transaction from '../../assets/transaction'
import ChangePlan from '../../assets/changePlan'
import HandBag from '../../assets/handBag'
import SignOut from '../../assets/signOut'
import Cart from '../../assets/cart'
import OrderHistory from '../../assets/orderHistory'
import Wishlist from '../../assets/wishlist'
import Address from '../../assets/address'
import { AppContext } from '../../context/app'
// import { isEmpty } from 'lodash'

const NavBarDropDown = ({ backgroundColor, titleColor }) => {
  const { t } = useTranslation()
  const [selectedMenu, setSelectedMenu] = useState('main')
  const { logoutCall, handleSubscription } = useTemplateHook()
  const { modulePermissions } = useContext(AppContext)

  return (
    <div
      style={{
        backgroundColor: backgroundColor,
        border: 'solid 0.5px #fff',
        zIndex: 50,
        minWidth: '180px',
        borderRadius: '10px',
      }}
      className="hidden xl:block absolute right-0  px-3  shadow border mt-3"
    >
      {selectedMenu === 'main' && (
        <ul style={{ color: titleColor }} className="py-1" aria-labelledby="dropdown">
          <li>
            <Link
              to="/profile"
              className="flex items-center gap-3 px-2 py-2 cursor-pointer user-dropdown-menu hover:bg-[#707070]/25 hover:rounded-[4px] w-full"
            >
              <Profile height={'14px'} width={'14px'} />
              <p className="text-sm block">{t('my_profile')}</p>
            </Link>
          </li>
          <li>
            <Link
              to="/watchlist"
              className="flex items-center gap-3 px-2 py-2 cursor-pointer user-dropdown-menu hover:bg-[#707070]/25 hover:rounded-[4px] w-full"
            >
              <Watchlist height={'14px'} width={'14px'} />
              <p className="text-sm block">{t('my_watchlist')}</p>
            </Link>
          </li>
          <li>
            <Link
              to="/favourites"
              className="flex items-center gap-3 px-2 py-2 cursor-pointer user-dropdown-menu hover:bg-[#707070]/25 hover:rounded-[4px] w-full"
            >
              <Favorite height={'14px'} width={'14px'} />
              <p className="text-sm block">{t('my_favorites')}</p>
            </Link>
          </li>
          <li>
            <Link
              to="/subscriptions"
              className="flex items-center gap-3 px-2 py-2 cursor-pointer user-dropdown-menu hover:bg-[#707070]/25 hover:rounded-[4px] w-full"
            >
              <Subscription height={'14px'} width={'14px'} />
              <p className="text-sm block">{t('my_subscriptions')}</p>
            </Link>
          </li>
          <li>
            <Link
              to="/transactions"
              className="flex items-center gap-3 px-2 py-2 cursor-pointer user-dropdown-menu hover:bg-[#707070]/25 hover:rounded-[4px] w-full"
            >
              <Transaction height={'14px'} width={'14px'} />
              <p className="text-sm block">{t('Transactions')}</p>
            </Link>
          </li>
          <li
            className="flex items-center gap-3 px-2 py-2 cursor-pointer user-dropdown-menu hover:bg-[#707070]/25 hover:rounded-[4px] w-full"
            onClick={handleSubscription}
          >
            <ChangePlan height={'14px'} width={'14px'} />
            <p className="text-sm block">{t('change_plan')}</p>
          </li>
          {modulePermissions?.ecommerce ? (
            <li
              onClick={(e) => {
                e.stopPropagation()
                setSelectedMenu('shop')
              }}
            >
              <Link className="flex items-center justify-between px-2 py-2 cursor-pointer user-dropdown-menu hover:bg-[#707070]/25 hover:rounded-[4px] w-full">
                <div className="flex items-center gap-3">
                  <HandBag height={'14px'} width={'14px'} />
                  <span className="text-sm">Shop</span>
                </div>
                <img src={nextArrow} className="w-4 h-4" alt="arrow" />
              </Link>
            </li>
          ) : null}

          <hr style={{ border: '0.5px solid #575757' }} />
          {/*<li>*/}
          {/*  <Link to="/faq">*/}
          {/*    <p className="text-lg text-white block px-4 py-2 cursor-pointer user-dropdown-menu">*/}
          {/*      Help*/}
          {/*    </p>*/}
          {/*  </Link>*/}
          {/*</li>*/}
          <li
            className="flex items-center gap-3 px-2 py-2 cursor-pointer user-dropdown-menu hover:bg-[#707070]/25 hover:rounded-[4px] w-full"
            onClick={logoutCall}
          >
            <SignOut height={'14px'} width={'14px'} />
            <p className="text-sm block">{t('sign_out')}</p>
          </li>
        </ul>
      )}
      {selectedMenu === 'shop' && (
        <ul style={{ color: titleColor }} className="py-1" aria-labelledby="dropdown">
          <li
            className="flex items-center px-2 gap-3 cursor-pointer mb-2 hover:bg-[#707070]/25 hover:rounded-[4px] w-full"
            onClick={(e) => {
              e.stopPropagation()
              setSelectedMenu('main')
            }}
          >
            <span className="w-2 h-2 flex items-center justify-center">←</span>
            <HandBag height={'14px'} width={'14px'} />
            <Link className="">
              <span className="text-sm">Shop</span>
            </Link>
          </li>

          <hr style={{ border: '0.5px solid #575757' }} />
          <ul className="flex flex-col">
            <li>
              <Link
                to="/cart-details"
                className="flex items-center gap-3 px-2 py-2 cursor-pointer user-dropdown-menu hover:bg-[#707070]/25 hover:rounded-[4px] w-full"
              >
                <div className="w-2 h-2"></div>
                <Cart height={'14px'} width={'14px'} />
                <p className="text-sm">My Cart</p>
              </Link>
            </li>
            <li>
              <Link
                to="/order-history"
                className="flex items-center gap-3 px-2 py-2 cursor-pointer user-dropdown-menu hover:bg-[#707070]/25 hover:rounded-[4px] w-full"
              >
                <div className="w-2 h-2"></div>
                <OrderHistory height={'14px'} width={'14px'} />
                <p className="text-sm">Order History</p>
              </Link>
            </li>
            <li>
              <Link
                to="/wish-list"
                className="flex items-center gap-3 px-2 py-2 cursor-pointer user-dropdown-menu hover:bg-[#707070]/25 hover:rounded-[4px] w-full"
              >
                <div className="w-2 h-2"></div>
                <Wishlist height={'14px'} width={'14px'} />
                <p className="text-sm">Wishlist</p>
              </Link>
            </li>
            <li>
              <Link
                to="/manage-address"
                className="flex items-center gap-3 px-2  py-2 cursor-pointer user-dropdown-menu hover:bg-[#707070]/25 hover:rounded-[4px] w-full"
              >
                <div className="w-2 h-2"></div>
                <Address height={'14px'} width={'14px'} />
                <p className="text-sm">My Addresses</p>
              </Link>
            </li>
          </ul>
        </ul>
      )}
    </div>
  )
}

export default NavBarDropDown
